import { CalendarColorFul } from "@monta/icons";
import { omit } from "../../../utils/object";
import DropDown, { useDropDown } from "../../DropDown";
import type { TextFieldProps } from "../TextField";
import TextField from "../TextField";
import styles from "./Datepicker.module.scss";
import FlatDatePicker from "./Flat";

export interface DatepickerProps
  extends Omit<TextFieldProps, "value" | "onChange"> {
  value?: any | null;
  onChange?: (value: any) => void;
  range?: boolean;
}

const Datepicker = (props: DatepickerProps) => {
  const { value } = props;

  const controller = useDropDown();

  return (
    <>
      <DropDown
        {...controller}
        stayOpenOnClick
        nudgeY={8}
        button={
          <TextField
            innerbefore={<CalendarColorFul />}
            {...(omit(props, ["value", "onChange"]) as any)}
            value={
              Array.isArray(value)
                ? value[0]
                  ? "از " +
                    value
                      .filter(Boolean)
                      .map((i) =>
                        i?.standardFormat({
                          jalali: true,
                          template: "YYYY/MM/DD",
                        }),
                      )
                      .join(" تا ")
                  : ""
                : value?.standardFormat({
                    jalali: true,
                    template: "YYYY/MM/DD",
                  })
            }
            wrapperClassName={styles["input"]}
            readOnly
          />
        }
      >
        <FlatDatePicker
          {...props}
          hasFooterBtns={true}
          close={controller.close}
        />
      </DropDown>
    </>
  );
};

export default Datepicker;
